import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, Output, inject, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from '@app/core/services/API/api-service';
import { Spinner } from '@app/shared/components/spinner/spinner';

@Component({
  selector: 'app-invoice-detail-modal',
  standalone: true,
  imports: [CommonModule, MatIconModule, Spinner],
  templateUrl: './invoice-detail-modal.html',
  styleUrl: './invoice-detail-modal.scss'
})
export class InvoiceDetailModal {
  @Input() invoice: any | null = null;
  @Input() invoiceFromAddress: any | null = null;
  @Input() companyID: string | null = null;
  @Output() close = new EventEmitter<void>();

  private toastr = inject(ToastrService);
  private apiService = inject(ApiService);

  readonly isLoading = signal<boolean>(false);

  @HostListener('document:keydown.escape')
  onEscKey(): void {
    this.onClose();
  }

  onBackdropClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (target.classList.contains('invoice-modal-backdrop')) {
      this.onClose();
    }
  }

  onClose(): void {
    this.close.emit();
  }

//   downloadInvoice(): void {
//     const invoiceContent = document.querySelector('.invoice-wrapper');
//     if (!invoiceContent) return;

//     const invoiceNumber = this.invoice?.invoiceNumber || 'Invoice';
//     const invoiceDate = this.invoice?.createDate ? new Date(this.invoice.createDate).toLocaleDateString() : new Date().toLocaleDateString();

//     const htmlContent = `
// <!DOCTYPE html>
// <html lang="en">
// <head>
//   <meta charset="UTF-8">
//   <meta name="viewport" content="width=device-width, initial-scale=1.0">
//   <title>Invoice ${invoiceNumber}</title>
//   <style>
//     * {
//       margin: 0;
//       padding: 0;
//       box-sizing: border-box;
//     }
//     body {
//       font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
//       padding: 40px;
//       background: #f9fafb;
//       color: #000;
//     }
//     .invoice-container {
//       max-width: 900px;
//       margin: 0 auto;
//       background: white;
//       padding: 50px;
//       border-radius: 8px;
//       box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
//     }
//     .invoice-header {
//       display: flex;
//       justify-content: space-between;
//       margin-bottom: 40px;
//       padding-bottom: 20px;
//       border-bottom: 3px solid #353668;
//       align-items: flex-start;
//     }
//     .invoice-title-section .invoice-title {
//       font-size: 42px;
//       font-weight: 700;
//       color: #353668;
//       margin-bottom: 10px;
//       text-transform: uppercase;
//     }
//     .invoice-number {
//       font-size: 18px;
//       font-weight: 600;
//       color: #374151;
//       margin-bottom: 5px;
//     }
//     .invoice-date {
//       font-size: 14px;
//       color: #6b7280;
//     }
//     .company-info {
//       text-align: right;
//       font-size: 14px;
//       line-height: 1.8;
//       color: #374151;
//     }
//     .company-name {
//       font-size: 20px;
//       font-weight: 700;
//       color: #90C544;
//       margin-bottom: 8px;
//     }
//     .invoice-parties {
//       display: flex;
//       justify-content: space-between;
//       margin-bottom: 40px;
//       gap: 40px;
//     }
//     .party-section {
//       flex: 1;
//       background: #f9fafb;
//       padding: 20px;
//       border-radius: 8px;
//     }
//     .party-label {
//       font-size: 11px;
//       font-weight: 600;
//       text-transform: uppercase;
//       color: #6b7280;
//       margin-bottom: 10px;
//       letter-spacing: 1px;
//     }
//     .party-name {
//       font-size: 17px;
//       font-weight: 700;
//       color: #111827;
//       margin-bottom: 8px;
//     }
//     .party-details {
//       font-size: 13px;
//       color: #4b5563;
//       line-height: 1.8;
//     }
//     .party-details div {
//       margin-bottom: 3px;
//     }
//     .invoice-table {
//       width: 100%;
//       border-collapse: collapse;
//       margin-bottom: 30px;
//       border: 1px solid #e2e8f0;
//       border-radius: 8px;
//     }
//     .invoice-table thead {
//       background: #353668;
//     }
//     .invoice-table th {
//       padding: 14px;
//       text-align: left;
//       font-size: 13px;
//       font-weight: 600;
//       color: white;
//       text-transform: uppercase;
//       letter-spacing: 0.5px;
//     }
//     .invoice-table th:nth-child(1) {
//       width: 15%;
//     }
//     .invoice-table th:nth-child(2) {
//       width: 35%;
//     }
//     .invoice-table th:nth-child(3) {
//       width: 15%;
//       text-align: center;
//     }
//     .invoice-table th:nth-child(4) {
//       width: 17.5%;
//       text-align: right;
//     }
//     .invoice-table th:nth-child(5) {
//       width: 17.5%;
//       text-align: right;
//     }
//     .invoice-table td {
//       padding: 14px;
//       font-size: 14px;
//       color: #374151;
//       border-bottom: 1px solid #e2e8f0;
//       background: white;
//     }
//     .invoice-table td:nth-child(3) {
//       text-align: center;
//     }
//     .invoice-table td:nth-child(4),
//     .invoice-table td:nth-child(5) {
//       text-align: right;
//     }
//     .invoice-table tbody tr:last-child td {
//       border-bottom: none;
//     }
//     .invoice-summary {
//       margin-left: auto;
//       width: 350px;
//       margin-bottom: 30px;
//       border: 1px solid #e5e7eb;
//       border-radius: 8px;
//       overflow: hidden;
//     }
//     .summary-row {
//       display: flex;
//       justify-content: space-between;
//       padding: 12px 16px;
//       font-size: 14px;
//       background: white;
//       border-bottom: 1px solid #e5e7eb;
//     }
//     .summary-row:last-child {
//       border-bottom: none;
//     }
//     .summary-row.total {
//       background: #f3f4f6;
//       font-weight: 700;
//       font-size: 16px;
//       color: #111827;
//       padding: 16px;
//     }
//     .summary-row.total span:last-child {
//       color: #353668;
//       font-size: 18px;
//     }
//     .summary-row.amount-paid {
//       background: white;
//       font-weight: 600;
//     }
//     .summary-row.amount-paid span:last-child {
//       color: #10b981;
//       font-weight: 700;
//     }
//     .summary-row.amount-due {
//       background: #f3f4f6;
//       font-weight: 700;
//       font-size: 14px;
//       border-top: 2px solid #e5e7eb;
//     }
//     .summary-row.amount-due span:first-child {
//       text-transform: uppercase;
//       letter-spacing: 0.5px;
//     }
//     .summary-row.amount-due span:last-child {
//       color: #353668;
//       font-size: 15px;
//       font-weight: 700;
//     }
//     .invoice-footer {
//       margin-top: 50px;
//       padding-top: 20px;
//       border-top: 2px solid #e5e7eb;
//       font-size: 13px;
//       color: #6b7280;
//       text-align: center;
//       line-height: 1.8;
//     }
//     .invoice-footer p:first-child {
//       font-weight: 600;
//       color: #374151;
//       margin-bottom: 5px;
//     }
//     .invoice-disclaimer {
//       margin-top: 20px;
//       padding: 16px 20px;
//       background: #f9fafb;
//       border-radius: 8px;
//       border: 1px solid #e5e7eb;
//     }
//     .invoice-disclaimer .disclaimer-section {
//       margin-bottom: 12px;
//     }
//     .invoice-disclaimer .disclaimer-section:last-child {
//       margin-bottom: 0;
//     }
//     .invoice-disclaimer strong {
//       display: block;
//       font-size: 13px;
//       font-weight: 700;
//       color: #111827;
//       margin-bottom: 4px;
//     }
//     .invoice-disclaimer p {
//       margin: 0;
//       font-size: 12px;
//       color: #374151;
//       line-height: 1.6;
//     }
//     @media print {
//       body {
//         padding: 0;
//         background: white;
//       }
//       .invoice-container {
//         box-shadow: none;
//         padding: 30px;
//       }
//     }
//   </style>
// </head>
// <body>
//   <div class="invoice-container">
//     ${invoiceContent.innerHTML}
//   </div>
// </body>
// </html>`;

//     // Create a Blob with the HTML content
//     const blob = new Blob([htmlContent], { type: 'text/html' });
//     const url = window.URL.createObjectURL(blob);
    
//     // Create a temporary link element
//     const link = document.createElement('a');
//     link.href = url;
//     link.download = `Invoice_${invoiceNumber.replace(/[^a-zA-Z0-9]/g, '_')}_${invoiceDate.replace(/\//g, '-')}.html`;
    
//     // Trigger the download
//     document.body.appendChild(link);
//     link.click();
    
//     // Clean up
//     document.body.removeChild(link);
//     window.URL.revokeObjectURL(url);
//   }

  downloadInvoice(): void {
    this.isLoading.set(true);
    this.apiService.generateInvoicePDF(this.companyID || '', this.invoice?.invoiceId || null).subscribe({
      next: (Blob: Blob) => {
        const url = window.URL.createObjectURL(Blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `Invoice_${this.invoice?.invoiceNumber || 'Invoice'}_${new Date().toISOString().split('T')[0]}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.onClose();
        this.toastr.success('Invoice downloaded successfully.');
        this.isLoading.set(false);
      },
      error: (error) => {
        this.toastr.error('Failed to download invoice. Please try again.');
        this.isLoading.set(false);
      }
    });
  } 

  getStatusClass(): string {
    if (!this.invoice?.paymentStatus) return 'status-pending';
    const status = this.invoice.paymentStatus.toLowerCase();
    if (status === 'paid') return 'status-paid';
    if (status === 'overdue') return 'status-overdue';
    return 'status-pending';
  }

  getSubtotal(): number {
    if (!this.invoice?.lines?.length) {
      return this.invoice?.amount?.amount || 0;
    }
    return this.invoice.lines.reduce((sum: number, line: any) => {
      const qty = line.qty || 0;
      const unitCost = line.unitCost?.amount || 0;
      return sum + (qty * unitCost);
    }, 0);
  }


  // Avoid duplicate taxes
  getUniqueTaxes(): Array<{ taxName1: string; taxAmount1: number }> {
    if (!this.invoice?.lines?.length) {
      return [];
    }

    const taxMap = new Map<string, { taxName1: string; taxAmount1: number }>();

    this.invoice.lines.forEach((line: any) => {
      if (line?.taxName1 && line?.taxAmount1) {
        const key = `${line.taxName1}_${line.taxAmount1}`;
        if (!taxMap.has(key)) {
          taxMap.set(key, {
            taxName1: line.taxName1,
            taxAmount1: line.taxAmount1
          });
        }
      }
    });

    return Array.from(taxMap.values());
  }

  // Calculate GST based on unique taxes
  getGST(): number {
    const uniqueTaxes = this.getUniqueTaxes();
    const subtotal = this.getSubtotal();
    
    return uniqueTaxes.reduce((sum: number, tax: { taxName1: string; taxAmount1: number }) => {
      return sum + (subtotal * tax.taxAmount1 / 100);
    }, 0);
  }

  getTotal(): number {
    const subtotal = this.getSubtotal();
    const gst = this.getGST();
    const discount = this.invoice?.discount || 0;
    return subtotal + gst - discount;
  }
}

